import { Text } from "@asayinc/component-library";
import { ScrollContainer } from "src/components/containers/ScrollContainer";

export function ClassActionEventStatsTab() {
  return (
    <ScrollContainer sx={{ pt: 8, pb: 10, pl: 10, pr: 6.25 }}>
      <Text variant="h5">Stats</Text>
    </ScrollContainer>
  );
}
